import * as React from "react";
const stopPropagation = (evt) => {
  evt.stopPropagation();
  evt.preventDefault();
};
const StopPropagation = ({ children }) => /* @__PURE__ */ React.createElement("span", { role: "presentation", onClick: stopPropagation, onMouseDown: stopPropagation }, children);
export default StopPropagation;
